/* global axios */
import ApiClient from './ApiClient';

class ControleAcessoAPI extends ApiClient {
  constructor() {
    super('controle_acesso', { accountScoped: true });
  }

  // GET /controle_acesso -> { usuarios: [...], custom_roles: [...] }
  fetch() {
    return axios.get(this.url);
  }

  // POST /controle_acesso
  //   individual: { user_id, blocklist }
  //   lote:       { user_ids: [...], blocklist }
  save({ user_id, user_ids, blocklist, padronizar, profile_key }) {
    return axios.post(this.url, {
      user_id,
      user_ids,
      blocklist,
      padronizar,
      profile_key,
    });
  }

  // Funcoes restritas (v87): flags do usuario logado + definicao (id1)
  minhasFuncoes() {
    return axios.get(`${this.url}/minhas_funcoes`);
  }

  salvarFuncaoRestrita(funcao, userIds) {
    return axios.post(`${this.url}/funcoes_restritas`, {
      funcao,
      user_ids: userIds,
    });
  }
}

export default new ControleAcessoAPI();
